import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import moment from "moment";
import React, { Component } from "react";
import { PATHS } from "../../common/constants";
import AssetDocuments from "./AssetDocuments";
import AssetNotes from "./AssetNotes";
import AssetMaintenance from "./AssetMaintenanceGuide";
import Breadcrumb from "../../components/Breadcrumb";
import HeadingWithDetails from "../../components/HeadingWithDetails";
import Icon from "../../components/Icon";
import Metrics from "../../components/Metrics";
import Tabs from "../../components/Tabs";
import WithNavigation from "../../layouts/WithNavigation";
import Card from "../../components/Card";
import Label from "../../components/Label/Label";
import Button from "../../components/Button";
import Loader from "../../components/Loader";

import {
  fetchFaqsNotesDocuments,
  fetchMaintenanceGuideForAssetByItemId,
  fetchFaqsForAssetByItemId,
  clearFaqsNotesDocuments,
  fetchFaqsNotesDocumentForAssetByAssetId,
  clearNotes,
} from "../../store/actions/faqsNotesDocuments";
import {
  selectNotes,
  selectDocuments,
  selectMaintenanceGuides,
  selectFaqs,
} from "../../store/selectors/faqsNotesDocuments";

import { updateAsset, deleteAsset } from "../../store/actions/assets";
import {
  setAssetFormData,
  clearAssetFormData,
} from "../../store/actions/assetForm";
import Overlay from "../../components/Overlay";
import AssetForm from "../../components/AssetForm";
import { selectAuthenticatedUser } from "../../store/selectors/auth";
import AssetFaqs from "./AssetFaqs";
import {
  selectAssetByAreaAndAssetId,
  selectAreaById,
} from "../../store/selectors/assets";
// import variables from '../../styles/includes/variables.scss';

import { variables } from "../../Tenants";
import ItemSpecifications from "../Item/ItemSpecifications";
import { selectSpecifications } from "../../store/selectors/Specifications";
import * as client from "../../services/client";
import { clearFndFormData } from "../../store/actions/fndForm";

class Asset extends Component {
  state = {
    showOverlay: false,
    specificItem: [],
    loader: false,
  };

  async componentDidMount() {
    const { onFetchFaqsNotesDocuments, clearFaqsNotesDocuments, clearNotes } =
      this.props;
    this.props.clearFndFormData();
    clearNotes();
    clearFaqsNotesDocuments();
    const asset = this.props.location.state.asset;
    await onFetchFaqsNotesDocuments(asset.id, "itemdata");
    client.fetchSpecifications(asset.item.id).then((response) => {
      this.setState({ loader: true });
      if (response.status === 200) {
        response.json().then((responsejson) => {
          if (responsejson.statusCode === 200) {
            this.setState({ specificItem: responsejson.data, loader: false });
          } else {
            this.setState({ specificItem: [], loader: false });
          }
        });
      } else {
        this.setState({ specificItem: [], loader: false });
      }
    });
  }

  onSaveAsset = (asset) => {
    const { suite, property } = this.props.location.state;
    let params = {};
    if (asset.id) {
      params = {
        id: asset.id,
        Name: asset.item.name,
        unitId: suite.id,
        AreaId: asset.areaId,
        ItemId: asset.itemId ? asset.itemId : asset.item.id,
        RoomType: asset.roomType,
        UserId: this.props.user.id,
        DateOfPurchase: asset.dateOfPurchase
          ? new Date(moment(asset.dateOfPurchase).format("l LT"))
          : new Date(moment().format("MM-DD-YYYY")),
        VendorId: asset && asset.vendorId ? asset.vendorId : null,
        VendorName: asset && asset.vendorId ? asset.vendorName : "",
      };
      if (!asset.vendorId) {
        delete params.VendorId;
        delete params.VendorName;
      }
      this.props.onUpdateAsset(params, this.props.history, suite, property);
    }
  };

  onDeleteAsset = (assetId) => {
    const { area, user } = this.props;
    const { suite, property } = this.props.location.state;
    this.props.onDeleteAsset(
      area.id,
      assetId,
      this.props.history,
      suite,
      property,
      user.id
    );
  };

  render() {
    const { suite, property } = this.props.location.state;
    const {
      notes,
      documents,
      setAssetFormData,
      clearAssetFormData,
      maintenance,
      faqs,
      user,
      asset,
      area,
      specificationsList,
      notesList,
    } = this.props;
    var HmeOwnrOcpntRltrNotes = [];
    var noteVisibleToHomeownerOccupantRealtor = false;
    if (
      notesList !== undefined &&
      notesList !== null &&
      notesList !== "" &&
      notesList.length > 0
    ) {
      let notes = notesList.filter((x) => x.type === "NOTES");
      if (notes.length > 0) {
        notes.forEach((object) => {
          HmeOwnrOcpntRltrNotes.push(
            JSON.parse(JSON.parse(JSON.stringify(object.data)))
          );
        });
      }
      if (HmeOwnrOcpntRltrNotes.length > 0) {
        let filterNotes = HmeOwnrOcpntRltrNotes.filter(
          (x) => x.noteVisibleToHomeownerOccupantRealtor === true
        );
        if (filterNotes.length > 0) {
          noteVisibleToHomeownerOccupantRealtor = true;
        }
      }
    }
    const { showOverlay } = this.state;
    let homeOwnerCheck =
      user &&
      user.roles &&
      user.roles.length > 0 &&
      (user.roles[0].role.name === "Home Owner" ||
        user.roles[0].role.name === "Realtor" ||
        user.roles[0].role.name === "Occupant")
        ? true
        : false;
    let activeTab = 0;
    let location = this.props.location;
    if (location && location.state && location.state.activeTab) {
      activeTab = location.state.activeTab;
    }
    const noSpecificationTabs = [
      {
        label: "Manuals & Documents",
        count: documents.length.toString(),
        content: <AssetDocuments asset={asset} />,
      },
      {
        label: "Maintenance Reminders",
        count: maintenance.length.toString(),
        content: <AssetMaintenance asset={asset} />,
      },
      {
        label: "FAQs",
        count: faqs.length.toString(),
        content: <AssetFaqs asset={asset} />,
      },
      homeOwnerCheck && noteVisibleToHomeownerOccupantRealtor === false
        ? {}
        : {
            label: "Notes",
            count: notes.length.toString(),
            content: <AssetNotes asset={asset} />,
          },
    ];

    const withSpecificationTabs = [
      {
        label: "Specifications",
        count: specificationsList.length.toString(),
        content: <ItemSpecifications item={asset.item} />,
      },
      {
        label: "Manuals & Documents",
        count: documents.length.toString(),
        content: <AssetDocuments asset={asset} />,
      },
      {
        label: "Maintenance Reminders",
        count: maintenance.length.toString(),
        content: <AssetMaintenance asset={asset} />,
      },
      {
        label: "FAQs",
        count: faqs.length.toString(),
        content: <AssetFaqs asset={asset} />,
      },
      homeOwnerCheck && noteVisibleToHomeownerOccupantRealtor === false
        ? {}
        : {
            label: "Notes",
            count: notes.length.toString(),
            content: <AssetNotes asset={asset} />,
          },
    ];
    const { specificItem } = this.state;
    if (asset) {
      return (
        <WithNavigation
          title={asset.item && asset.item.name}
          top={
            <HeadingWithDetails
              style={{
                backgroundImage: "url(/assets/banner-property.png)",
              }}
              breadcrumb={
                <Breadcrumb
                  to={{
                    pathname: PATHS.SUITES_VIEW.replace(
                      ":id",
                      property.id + "&" + suite.id
                    ),
                    state: {
                      suite: suite,
                      property: property,
                      onNavigationBack: true,
                    },
                  }}
                  label={variables.Suite + " " + suite.number}
                />
              }
              headline={asset.item && asset.item.name}
              items={[
                <Card
                  body={
                    <>
                      MAKE:{" "}
                      {asset.item && asset.item.makeName
                        ? asset.item.makeName
                        : "—"}{" "}
                      <br />
                      MODEL:{" "}
                      {asset.item && asset.item.model
                        ? asset.item.model
                        : "—"}{" "}
                      <br />
                      INSTALLED ON:{" "}
                      {asset.dateOfPurchase && asset.dateOfPurchase
                        ? moment(asset.dateOfPurchase).format("MM/DD/YYYY")
                        : ""}
                    </>
                  }
                />,
                <Metrics
                  items={[
                    {
                      key: "Active",
                      value: asset.serviceActive,
                    },
                    {
                      key: "Archived",
                      value: asset.serviceArchived,
                    },
                  ]}
                />,
                <Card
                  title="Warranty Expiration"
                  body={
                    <Label
                      color={
                        asset.warrantDays < 30
                          ? "red"
                          : asset.warrantDays < 60
                          ? "yellow"
                          : "teal"
                      }
                      label={
                        asset.warrantExpiration && asset.warrantExpiration
                          ? moment(asset.warrantExpiration).format("MM/DD/YYYY")
                          : ""
                      }
                    />
                  }
                />,
                <Card
                  title="Type/Room"
                  body={
                    <>
                      {asset.item && asset.item.typeName
                        ? asset.item.typeName
                        : ""}
                      /{area.customLabel ? area.customLabel : area.name}
                    </>
                  }
                />,
              ]}
              actions={
                homeOwnerCheck ? null : (
                  <>
                    <Button
                      color="semantic"
                      onClick={() => {
                        this.setState({ showOverlay: true });
                        setAssetFormData({
                          ...asset,
                          areaId: area.areaId,
                          assetWarrantyDefaultStartDate:
                            suite.assetWarrantyDefaultStartDate,
                        });
                      }}
                      label={<Icon glyph="pencil" weight="light" />}
                    />
                    <Button
                      color="semantic"
                      onClick={() =>
                        window.confirm(
                          `Are you sure you want to delete ${asset.item.name}?`
                        ) && this.onDeleteAsset(asset.id)
                      }
                      label={<Icon glyph="trash" weight="light" />}
                    />
                    <Overlay
                      showOverlay={showOverlay}
                      content={
                        <AssetForm
                          propertyId={property.id}
                          onClose={() => {
                            this.setState(
                              { showOverlay: false, newAsset: false },
                              () => clearAssetFormData()
                            );
                          }}
                          onSaveAsset={(data) => this.onSaveAsset(data)}
                        />
                      }
                    />
                  </>
                )
              }
            />
          }
          bottom={
            <Tabs
              activeTab={activeTab}
              items={
                (user.roles[0].role.name === "Home Owner" ||
                  user.roles[0].role.name === "Realtor") &&
                specificItem.length === 0
                  ? noSpecificationTabs
                  : withSpecificationTabs
              }
            />
          }
        />
      );
    }

    return <Loader />;
  }
}

const mapStateToProps = (state, ownProps) => {
  let assetId = ownProps.match.params.id.split("&");
  let getAssetByAreaIdAndAssetId = selectAssetByAreaAndAssetId(
    state,
    assetId[0],
    assetId[1]
  );
  let area = selectAreaById(state, assetId[0]);
  return {
    area,
    asset: getAssetByAreaIdAndAssetId,
    notes: selectNotes(state),
    documents: selectDocuments(state),
    maintenance: selectMaintenanceGuides(state),
    faqs: selectFaqs(state),
    user: selectAuthenticatedUser(state),
    specificationsList: selectSpecifications(state),
    notesList: state.notes,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onFetchFaqsNotesDocuments: fetchFaqsNotesDocuments,
      onFetchMaintenanceGuideForAssetByItemId:
        fetchMaintenanceGuideForAssetByItemId,
      onFetchFaqsForAssetByItemId: fetchFaqsForAssetByItemId,
      onUpdateAsset: updateAsset,
      onDeleteAsset: deleteAsset,
      setAssetFormData,
      clearAssetFormData,
      clearFaqsNotesDocuments,
      fetchFaqsNotesDocumentForAssetByAssetId:
        fetchFaqsNotesDocumentForAssetByAssetId,
      clearNotes,
      clearFndFormData,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Asset);
